import style from './GroupOptions.module.scss';

interface GroupItemLabelProps {
  name: string;
  alias?: string;
}

/**
 * Display-only label for a filter tree row: the response alias badge (when the
 * backend supplies one) above the unchanged full text (GH #77).
 */
export default function GroupItemLabel({ name, alias }: Readonly<GroupItemLabelProps>) {
  // The backend normalizes whitespace-only aliases to null; trim here too so a
  // frontend-only alias source can never render a blank or padded badge chip.
  const trimmedAlias = alias?.trim();
  if (!trimmedAlias) {
    return <>{name}</>;
  }

  return (
    <div className={style['group-item-label']}>
      <span className={style['response-alias-badge']} data-testid="response-alias-badge">
        {trimmedAlias}
      </span>
      <span>{name}</span>
    </div>
  );
}
